var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5141 11.5242C17.3066 11.5242 17.9491 12.3698 17.9491 13.413V32.3014C17.9491 33.3446 17.3066 34.1903 16.5141 34.1903C15.7216 34.1903 15.0791 33.3446 15.0791 32.3014V13.413C15.0791 12.3698 15.7216 11.5242 16.5141 11.5242Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9106 0.190918C31.7031 0.190918 32.3456 1.03658 32.3456 2.07976V32.3012C32.3456 33.3444 31.7031 34.1901 30.9106 34.1901C30.118 34.1901 29.4756 33.3444 29.4756 32.3012V2.07976C29.4756 1.03658 30.118 0.190918 30.9106 0.190918Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11858 22.8579C2.91111 22.8579 3.55358 23.7036 3.55358 24.7468V32.3021C3.55358 33.3453 2.91111 34.191 2.11858 34.191C1.32605 34.191 0.683578 33.3453 0.683578 32.3021V24.7468C0.683578 23.7036 1.32605 22.8579 2.11858 22.8579Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/DashIcon.0706ff6ddb90b68f3264277082cc6ab8.svg";
export { ForwardRef as ReactComponent };